export default "__VITE_ASSET__CryiKIfi__"